import { useTrans } from '../../../hooks/useTrans';

const DropCandidatesZone = () => {
  const { t } = useTrans();

  return (
    <div
      className="w-full bg-black"
      style={{
        backgroundColor: 'var(--neutral-100, #F3F4F6)',
        color: 'darkgrey',
        fontStyle: 'italic',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        height: '175px',
      }}
    >
      {t('responses-ranking-drop-zone-hint')}
    </div>
  );
};

export default DropCandidatesZone;
